<template>
    <div class="store-tag-editor responsive-menu">
      <div class="responsive-menu__child">
        <PageHeader
          :pageHeader="pageHeader"
          :links="[
            { name: 'home', label: 'Home' },
            { name: 'storeTags', label: 'Store Tags' },
            {
              name: 'storeTagEditor',
              label: selectedStoreTag.label,
              query: $route.query,
            },
          ]"
          :isEdit="isEdit"
          :isCollapsed="isCollapsed"
          :selectedEntity="selectedStoreTag"
          :hideAddButton="true"
          :canArchive="true"
          :canEdit="false"
          @updateIsEdit="isEdit = $event"
          :entity="entity"
          @toggle-edit="toggleEdit"
          @toggle-sections="forceToggle"
          @handle-adjacent="handleAdjacent"
          @show-search-modal="toggleSearchModal"
          @menu-option-click="menuOptionClick"
        />
        <div class="section-base">
          <div class="padded elevated-0 bordered">
            <div class="two-columns-layout two-columns-layout--responsive">
                <div v-for="inputs in storeTagInputs" :key="inputs.id">
                    <div class="grid-two-column two-columns-layout--responsive-horizontal-space-10">
                        <div v-for="input in inputs.inputs" :key="input.id" :class="'input-text' + ' ' + input.class"
                        >
                            <Input
                            :model="selectedStoreTag[input.id]"
                            @updateModel="selectedStoreTag[input.id] = $event"
                            :inputData="input"
                            :isEdit="isEdit"
                        />
                        </div>
                    </div>
                </div>
              </div>
          </div>
        </div>

        <!-- <EditorSection
          title="Associated Items"
          v-if="selectedStoreTag._id !== 'NEW'"
          :bus="bus"
        >
          <SearchTable
            :key="id"
            :entity="Entities.ITEM"
            :hideFilters="true"
            :filter="preFilter"
          />
        </EditorSection> -->

        <EditorSection
          :title="`About ${selectedStoreTag.label || ''}`"
          sectionType="about"
          v-if="selectedStoreTag._id !== 'NEW'"
          :bus="bus"
        >
          <About :entity="selectedStoreTag" />
        </EditorSection>
      </div>
      <SearchModal
        v-if="showSearchModal"
        :showSearchModal="showSearchModal"
        @toggle-modal="() => (showSearchModal = !showSearchModal)"
        :entity="entity"
        :forcedFilterCriteria="filterCriteria"
        :columnHeaders="columnHeaders"
      />
    </div>
  </template>

<script>
import Vue from "vue";
import PageHeader from "@/components/PageHeader.vue";
import About from "@/components/About/About.vue";
import { mapActions, mapGetters } from "vuex";
import Input from "@/components/Input/Input.vue";
import moment from "moment";
import _ from "lodash";
import Constants from "@/resources/Constants";
import EditorSection from "@/components/EditorSection";
import Entities from "@/resources/Entities";

import {
  storeTagInputs,
  columnHeaders,
  filterCriteria,
  pageHeader,
} from "./inputs";

export default {
  name: "storeTagEditor",
  data() {
    return {
      Constants: Constants,
      moment: moment,
      storeTagInputs,
      state: ["biotrack", "metrc"],
      isEdit: false,
      bus: new Vue(),
      isCollapsed: true,
      showSearchModal: false,
      columnHeaders,
      filterCriteria,
      entity: Entities.STORETAG,
      pageHeader,
      storeTags: [],
    };
  },
  components: {
    PageHeader,
    About,
    Input,
    EditorSection,
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.setMessagePopUp({
        isOpen: true,
        title: Constants.strings.unsavedChangesTitle,
        message: Constants.strings.unsavedChangesConfirmation,
        positiveCallback: (data) => {
          next(true);
        },
      });
    } else {
      next(true);
    }
  },
  watch: {
    id: function () {
      if (this.id && this.id !== "NEW") {
        this.getStoreTagById({
          _id: this.id,
        });
      }
    },
  },
  computed: {
    id: {
      get() {
        return this.$route.query.id;
      },
      set(id) {
        return id;
      },
    },
    ...mapGetters({
      loadingStatus: "storeTagModule/loadingStatus",
      storeTag: "storeTagModule/storeTag",
      getStoreTags: "storeTagModule/storeTags",
    }),
    selectedStoreTag: {
      get() {
        this.setPageTitle("StoreTags" + this.storeTag.label);
        return this.prefillItemBeforeRendering(this.storeTag);
      },
      set(entity) {
        return entity;
      },
    },
  },
  methods: {
    ...mapActions({
      getStoreTagById: "storeTagModule/getStoreTagById",
      saveStoreTag: "storeTagModule/saveStoreTag",
      deleteStoreTag: "storeTagModule/deleteStoreTag",
      setMessagePopUp: "setMessagePopUp",
      getAdjacent: "storeTagModule/getAdjacent",
      retrieveStoreTags: "storeTagModule/getStoreTags",
    }),
    forceToggle() {
      this.isCollapsed = !this.isCollapsed;
      this.bus.$emit("forceToggle", this.isCollapsed);
    },
    handleAdjacent: async function (mode) {
      this.getAdjacent({
        createdAt: this.selectedStoreTag.createdAt,
        mode,
        positiveCallback: (adjacent) => {
          if (adjacent) this.selectedStoreTag = adjacent;
        },
      });
    },
    toggleSearchModal: function () {
      this.showSearchModal = !this.showSearchModal;
    },
    prefillItem: function (item) {
    const itemSubsetToCopy = _.pick(item, ["name"]);
    function mergeEmptyItems(objValue, srcValue) {
      if (objValue) return objValue;
      return srcValue;
    }
    _.mergeWith(this.selectedStoreTag, itemSubsetToCopy, mergeEmptyItems);
    },

    clearItemFromSearch: function (entity) {
      this.selectedStoreTag[entity] = null;
    },

    selectItemFromSearch: function (entity, item) {
      if (entity === Entities.STORETAG && this.selectedStoreTag._id === "NEW")
        this.prefillItem(item);

      this.$set(this.selectedStoreTag, entity, item);
    },

    toggleEdit() {
      if (!(this.selectedStoreTag._id === "NEW")) this.isEdit = !this.isEdit;
      if (this.selectedStoreTag._id === "NEW") {
        this.isEdit = true;
      }
    },
    menuOptionClick(entity, key) {
      if (key === "storeTag-listing") {
        window.open(`/reports/inventory/inventoryListStoreTag`);
      }
    },
    closeHandler() {
      this.setStoreTagOrderingPopUpOpen(false);
    },
    saveHandler(updatedStoreTags) {
      this.updateStoreTagOrdering(updatedStoreTags).then(() => {
        this.closeHandler();
      });
    },
    prefillItemBeforeRendering(entity) {
    return entity;
  },
  },
  async mounted() {
    this.setPageTitle("StoreTag");
    if (this.$route.query.id) {
      this.getStoreTagById({
        _id: this.$route.query.id,
        positiveCallback: (storeTag) => {
          this.setPageTitle(`StoreTag ${storeTag.label}`);
        },
      });
    } else {
      this.isEdit = true;
      this.$store.commit("storeTagModule/setStoreTag", { _id: "NEW" });
    }
    let storeTagsInStore = this.getStoreTags;
    if (!storeTagsInStore || storeTagsInStore.length == 0) {
      await this.retrieveStoreTags().then((data) => {
        storeTagsInStore = data;
      });
    }
  },
};
</script>